import { MultiSelect } from '@mantine/core';
import {
  ArrayNode,
  DefaultNodeOptions,
  getData,
  widget,
  WidgetPlugin,
} from '@sagold/react-json-editor';

import { FormField } from '../../../components/formfield/FormField';
import { FormLabel } from '../../../components/formlabel/FormLabel';

export type ExcludeSelectWidgetOptions = DefaultNodeOptions<{
  widget?: 'ExcludeSelectWidget';
}>;

export const ExcludeSelectWidget = widget<
  ArrayNode<ExcludeSelectWidgetOptions>,
  Record<string, string | boolean>[]
>(({ node, options, setValue }) => {
  // @todo: make more generic <FopiInvestor> & {selected: boolean}
  const arrayData = getData(node) as {
    investor: string;
    investorId: string;
    selected: boolean;
  }[];

  return (
    <FormField
      widgetType="string"
      node={node}
      options={options}
      className={['portal-tabs', ...(options.classNames ?? [])].join(' ')}
    >
      {options.title && (
        <FormLabel
          description={options.description}
          required={options.required}
          disabled={options.disabled}
          error={node.errors.length > 0}
          label={options.title}
        />
      )}
      <MultiSelect
        clearable
        searchable
        data={arrayData.map((i) => ({
          label: i.investor,
          value: i.investorId,
        }))}
        value={arrayData.filter((i) => !i.selected).map((i) => i.investorId)}
        onChange={(unselected) => {
          for (const item of arrayData) {
            item.selected = !unselected.includes(item.investorId);
          }
          // @todo use unselected list to sort arrayData
          setValue(arrayData);
        }}
      />
    </FormField>
  );
});

export const ExcludeSelectionWidgetPlugin: WidgetPlugin = {
  id: 'exclude-select-widget',
  use: (node) =>
    node.options.widget === 'ExcludeSelectWidget' &&
    node.schema.type === 'array',
  Widget: ExcludeSelectWidget,
};
